export default "__VITE_ASSET__df16b1e0__"